import { render, staticRenderFns } from "./Masslist.vue?vue&type=template&id=08c51dd6&scoped=true"
import script from "./Masslist.vue?vue&type=script&lang=js"
export * from "./Masslist.vue?vue&type=script&lang=js"
import style0 from "./Masslist.vue?vue&type=style&index=0&id=08c51dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c51dd6",
  null
  
)

export default component.exports